import type { SerializedConstructor } from '@langchain/core/load/serializable';

export function serializedModelNameEquals(
  serializedModel: SerializedConstructor | null,
  modelName: string
): boolean {
  return Boolean(
    serializedModel?.id &&
      Array.isArray(serializedModel.id) &&
      serializedModel.id.at(-1) === modelName
  );
}
